<template>
  <v-card variant="outlined">
    <v-col>
      <app-logo />
    </v-col>
    <v-card-title class="justify-center"> Invalid Referral Code </v-card-title>
  </v-card>
</template>
<script setup>
import AppLogo from "@/components/AppLogo.vue";
</script>
